<template>
  <div style="font-size: 14px;" class="topfixed">
    <div style="height: 40px;background-color: #f5f5f5;">
      <div style="display: flex;" class="contain-box">
        <div class="top-title" style="padding-right: 20px;line-height: 40px;color: #666;">嗨，欢迎来到<span style="color: #b31e22;">大有网</span></div>
        <!-- <div class="top-title" style="padding-right: 20px;line-height: 40px;color: #666;margin-left: 20px;" @click="toConsignmentPage">网店代销</div>
        <div class="top-title" style="padding-right: 20px;line-height: 40px;color: #666;margin-left: 20px;" @click="toHelpPage">帮助中心</div> -->
        <div style="flex: 1;display: flex;">
          <div style="flex: 1;"></div>
          <div style="width: 300px;display: flex;justify-content:end;">
            <div v-if="userInfo.id" style="display: flex;line-height: 40px;margin-right: 10px;">
              <div style="color: #666;" class="top-title" v-if="!userInfo.id" @click="toLogin">登录</div>
              <el-dropdown v-if="userInfo.id">
                <div style="display: flex;overflow:hidden;">
                  <el-image :src="JSON.stringify(avatar)!='{}'?avatar:imgavatar" style="width: 30px;height: 30px;margin: 5px 0;border-radius: 50%;"></el-image>
                  <div style="max-width: 70px;height: 40px;margin: 0px 5px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
                    {{userInfo.username}}
                  </div>
                  <i class="el-icon-arrow-down" style="line-height: 40px;"></i>
                </div>
                <el-dropdown-menu slot="dropdown" style="margin-top: 0;">
                  <el-dropdown-item @click.native="toUserInfo">个人中心</el-dropdown-item>
                  <el-dropdown-item @click.native="logout">退出登录</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>

        </div>
      </div>
    </div>

    <div class="contain-box" style="height: 100px;line-height: 100px;">
      <div style="display: flex;">
        <div style="width: 200px;height: 100px;" @click="selMenus('/home/index')">
          <img :src="logo" style="cursor: pointer;width: 200px;height: 100px;">
        </div>
        <div style="flex: 1;text-align: center;padding: 0 50px;">
          <el-input placeholder="搜索商品" v-model="input" style="width: 100%;margin-top: 30px;" @change="search(input)">
            <el-button slot="append" icon="el-icon-search" @click="search(input)"></el-button>
          </el-input>
        </div>
        <div style="width: 200px;text-align: center;">
          <el-button type="warning" icon="el-icon-shopping-cart-2" @click="toCar">购物车</el-button>
        </div>
      </div>
    </div>

    <div style="height: 40px;background-color: #333;">
      <div class="contain-box" style="display: flex;position: relative;">
        <div style="color: #FFFFFF;width: 200px;" class="all-type bfe4">
          <div>
            <i class="el-icon-menu" style="line-height: 40px;margin-left: 10px;"></i>
            <span style="line-height: 40px;" >全部分类</span>
            <!-- v-if="menuPath!=='/home/index'" -->
            <div v-if="routeUrl!=='/home/index'" style="position:absolute;z-index: 2000;" class="big-menu">
            
              <div style="display: flex;">
                <div class="scroll-none pr" style="width: 200px;background-color: #fff;height: 500px;overflow: scroll;">
                  <div style="">
                    <div :class="{'category-active':(active==index && showChildren)}" v-for="(item,index) in listData" :key="index" @mouseenter="enter(item,index)" @mouseleave="leave" 
                    style="padding: 0 10px;height: 40px;line-height: 40px;transition: background-color .2s ease;">
                      <div class="fenlei">
                        <div class="category--lable-active" @click="typePage(item1.categoryId)" style="cursor: pointer;">
                          {{item.name}}
                        </div>
                        <!-- <el-link :underline="false" style="color: #333;" @click="typePage(item.categoryId)">{{item.name}}</el-link> -->
                        <i class="el-icon-arrow-right" style="color: #333;"></i>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- v-if="hover" -->
                <div v-if="showChildren" v-loading="!hover" @mouseenter="enter()" @mouseleave="leave" class="scroll-none" style="width:1200px;height: 500px;overflow: scroll;z-index:80">
                  <!-- background-color: rgba(48, 48, 48, .8); -->
                  <div style="background-color:#ffffff;">
                    <div style="margin: 0 10px;">
                      <div v-for="(item1,index1) in subMenusOfHover" :key="index1" style="color:#333;line-height: 30px;padding: 10px 0;">
                        <div class="category--lable-active" @click="typePage(item1.categoryId)" style="cursor: pointer;">
                          {{item1.name}}
                        </div>
                        <div style="flex: 1;margin-left: 20px;">
                          <div v-for="(item2,index2) in item1.children" :key="index2" style="margin: 0 10px;display: inline-block;" class="sub-menu category--lable-active" @click="typePage(item2.categoryId)">
                            {{item2.name}}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- <div class="scroll-none" style="width: 200px;background-color: #333;height: 505px;overflow: scroll;">
                <div style="border-bottom: 1px solid #666;">
                  <div v-for="i in 5" :key="i" @mouseenter="enter(i)" @mouseleave="leave" style="padding: 0 10px;">
                    <div style="color: #FFFFFF;margin-top: 10px;"><i class="el-icon-shopping-bag-2" style="margin-right: 10px;"></i>女装</div>
                    <div style="display: inline-block;margin: 10px 10px 10px 0;">
                      <div><el-link :underline="false" style="color: #999;">上装</el-link></div>
                    </div>
                    <div style="display: inline-block;margin: 10px 10px 10px 0;">
                      <div><el-link :underline="false" style="color: #999;">下装</el-link></div>
                    </div>
                    <div style="display: inline-block;margin: 10px 10px 10px 0;">
                      <div><el-link :underline="false" style="color: #999;">裙装</el-link></div>
                    </div>
                    <div style="display: inline-block;margin: 10px 10px 10px 0;">
                      <div><el-link :underline="false" style="color: #999;">内衣</el-link></div>
                    </div>
                  </div>
                </div>
              </div> -->

              <!-- <div v-if="hover" @mouseenter="enter()" @mouseleave="leave" class="scroll-none" style="width: 500px;height: 530px;overflow: scroll;margin-top:-505px;margin-left: 200px;">
                <div style="background-color: rgba(48, 48, 48, .8);">
                  <div style="margin: 0 10px;border-bottom: 1px solid #666;">
                    <div v-for="(item1,index1) in subMenusOfHover" :key="index1" style="display: flex;color: #FFFFFF;line-height: 30px;padding: 10px 0;">
                      <div>
                        {{item1.typeName}}：
                      </div>
                      <div style="flex: 1;border-bottom: 1px solid #FFFFFF;margin-left: 20px;">
                        <div v-for="(item2,index2) in item1.items" :key="index2" style="margin: 0 10px;display: inline-block;" class="sub-menu" @click="typePage">
                          {{item2.name}}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div> -->


            </div>
          </div>
        </div>
        <div style="line-height: 40px;" v-for="(item,index) in menus" :key="index" :class="'menu-index '+(menuPath===item.path?'menu-active':'')" @click="selMenu(item)">
          {{item.pageName}}
        </div>



      </div>
    </div>




  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import {removeToken} from '../../utils/auth';
  import baseLogo from '../../../public/img/logo.png';
  import diyPage from '@/api/diyPage.js';
  import homePageApi from '@/api/homePageApi.js'
  export default {
      data() {
        return {
          logo:'',
          input:'',
          menuPath: '',
          hover: true,
          menus:[],
          imgavatar:require('../../../public/img/headerde.png'),
          productZoneId:'',
          routeUrl:'/home/index',
          timer:null,
          listData: [],
          /*子类数据*/
          childlist: [],
          subMenusOfHover:[],
          active:0,
          showChildren:true
        };
      },
      computed: {
        ...mapGetters([
          'userInfo',
          'avatar'
        ])
      },
      watch:{
        menuPath:function(n, o) {
          
        },
        $route: {
          handler:  function (val, oldVal){
            // console.log(val.path)
            this.routeUrl = val.path;
            let routeList = this.menus.filter(x=>x.path==val.path);
            if (routeList.length>0) {
              localStorage.setItem('categroy',JSON.stringify({
                path:routeList[0].path,
                name:routeList[0].pageName
              }))
              this.menuPath = val.path
            }
          },
          // 深度观察监听
          deep:  true
        }
      },
      created() {
        let that = this;
        this.routeUrl = this.$route.path;
        // that.menuPath = that.$router.currentRoute.path;
        let catemenu=JSON.parse(localStorage.getItem('categroy'))
        catemenu&&(that.menuPath=catemenu.path);
        that.$route.query.path&&(that.menuPath=that.$route.query.path)
        this.logo = localStorage.getItem('shopLogo')||baseLogo
        this.getData2(0);
      },
      mounted() {
        let that = this;
        that.getData();
        // setInterval(function(){
        //     // switch(that.$route.query.productZoneId){
        //     //   case '1':
        //     //     that.menuPath = '/lease';
        //     //     break;
        //     //   case '2':
        //     //     that.menuPath = '/enterprise/index';
        //     //     break;
        //     //   case '3':
        //     //     that.menuPath = '/contract/index';
        //     //     break;
        //     //   case '4':
        //     //     that.menuPath = '/shelf/index';
        //     //     break;
        //     //   case '':
        //     //     that.menuPath = '/home/index';
        //     //     break;
        //     // }
        //     // console.log(that.$router);
          
        // },300)
      },
      methods: {
        getData2(e,show) {
          let self=this;
          homePageApi.categorys({pid:e}, true)
            .then(data => {
              if(data.errCode==200){
                if(data.data[0].parentId==0){
                  self.listData = data.data;
                  self.getData2(data.data[0].categoryId)
                }else{
                  self.childlist = data.data;
                  self.subMenusOfHover=self.childlist;
                }
                // console.log(e);
                show&&(self.hover=show)
              }
            })
            .catch(error => {});
        },
        typePage(categoryId){
          let _query = {
            categoryId:categoryId
          }
          console.log();
          this.$route.query.productZoneId && (_query = Object.assign(_query,{productZoneId:this.$route.query.productZoneId}))
          switch(this.$route.path){
              case '/lease':
                _query = Object.assign(_query,{productZoneId:1})
                break;
              case '/enterprise/index':
                _query = Object.assign(_query,{productZoneId:2})
                break;
              case '/contract/index':
                _query = Object.assign(_query,{productZoneId:3})
                break;
              case '/shelf/index':
                _query = Object.assign(_query,{productZoneId:4})
                break;
          }
          this.$router.push({
              path: '/type/index',
              query:_query
          });
        },
        getData(){
          let self = this;
          diyPage.getlistData({}, true)
          .then(res => {
            let item=[...res.data].sort((a, b) => a.pageId - b.pageId);
            item.forEach((item)=>{
              switch(item.pageId){
                case 1:
                  item.path='/home/index';
                  break;
                case 2:
                  item.path='/lease';
                  item.value=4;
                  item.id=1;
                  break;
                case 3:
                  item.path='/enterprise/index'
                  item.value=4;
                  item.id=2;
                  break;
                case 4:
                  item.path='/contract/index'
                  item.value=5;
                  item.id=3;
                  break;
                case 5:
                  item.path='/shelf/index'
                  item.value=3;
                  item.id=4;
                  break;
              }
            })
            self.menus=item;
            // let items=self.menus.filter(item=>{
            //   return item.path===self.$router.currentRoute.path;
            //   ||catemenu&&(item.path==catemenu.path);
            // })
            // items.length!=0?self.productZoneId=items[0].id:''
            self.menus.forEach((data)=>{
              if(data.path===self.$router.currentRoute.path){
                self.menuPath = self.$router.currentRoute.path;
                self.productZoneId=data.id;
              }
            })
          })
          .catch(error => {});
        },
        search(input){
          if(this.$route.path=='/type/index'){
              this.$router.push({ 
                path: '/zhongzhuan',
                query: {
                  input: input,
                  productZoneId:this.productZoneId
                },
            });
          }
          this.$router.push({
            path: '/type/index',
            query:{
              input:input,
              productZoneId:this.productZoneId
            }
          });
        },
        selMenus(path){
          this.$router.push({path:path});
          this.menuPath='/home/index'
        },
        selMenu(item){
          let path;
          let userInfo=JSON.parse(localStorage.getItem('userInfo'))
          if(JSON.stringify(this.userInfo)=='{}' && item.path!='/home/index'){
            this.toLogin();
            return;
          }
          // if(this.menuPath === item.path){
          //   return;
          // }
          if(item.path=='/home/index'){
            this.productZoneId='';
            path='/home/index'
            localStorage.setItem('categroy',JSON.stringify(item))
          }else{
            if(item.value==userInfo.userType){
              this.productZoneId=item.id;
              path=item.path;
              localStorage.setItem('categroy',JSON.stringify(item))
            }else{
              this.$message({
                type: "warning",
                message: '无权限访问该专区'
              });
              return;
            }
          }
          this.menuPath = path;
          this.$router.push({path:path});
         },
        toLogin(){
          this.$router.push({path: '/login'});
        },
        toWel(){
          this.$router.push({path: '/personal/wel'});
        },
        toOrder(){
          this.$router.push({path: '/personal/order'});
        },
        toIntegral(){
          this.$router.push({path: '/personal/integral'});
        },
        toUserInfo(){
          this.$router.push({path: '/personal/userInfo'});
        },
        toConsignmentPage(){//网店代销

        },
        toHelpPage(){
          this.$router.push({path: '/personal/commonProblem'});
        },
        toCar(){
          this.$router.push({path: '/car'});
        },
        enter(id,index){
          this.hover = false;
          this.showChildren = true
          if (Object.prototype.toString.call(index)=='[object Number]') {
            this.active = index
          }
          if(id!=undefined){
            this.timer&&(clearTimeout(this.timer))
            this.timer = setTimeout(() => {
              // 这里写入希望执行的操作
              this.subMenusOfHover=[]
              this.getData2(id.categoryId,true);
              // this.hover = true;
            }, 300);
          }else{
            this.hover = true;
          }
          return
          if(id){
            if(id % 2 == 0){
              this.subMenusOfHover = this.subMenusOfHover1;
            }else{
              this.subMenusOfHover = this.subMenusOfHover2;
            }
          }
          this.hover = true;
        },
        leave(){
          // this.hover = false;
          // this.showChildren = false
        },
        logout(){//退出登录
          this.$confirm("确定退出登录?", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          })
            .then(() => {
              this.$notify({
                title: '提示',
                message: '退出成功',
                type: 'success'
                //duration: 0//为0则不会自动关闭
              });
              //清除用户信息缓存
              localStorage.removeItem('token');
              localStorage.removeItem('userInfo');
              this.$store.commit('SET_AVATAR', this.imgavatar);
              removeToken();
              this.$store.commit('SET_USER_INFO', {});
              // this.toLogin();
              this.$router.push({path: '/home/index'});
              location.reload();
            })
        },
        logout2() {//请求后端 真实退出
          this.$confirm('退出系统, 是否继续?', '', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: "warning"
          }).then(() => {
            this.$store.dispatch('logout').then((res)=>{
              if(res.code === 200){
                this.$notify({
                  title: '退出成功',
                  type: 'success'
                });
                this.$router.push({path: '/login'});
              }
            });
          });
        },
      }
    };
</script>

<style scoped>
  .category--lable-active{
    color: #333;
  }
  .category--lable-active:hover{
    color: #FE7912;
  }
  .category-active{
    background-color: #d9d9d9;
  }
  .top-title:hover{
    cursor: pointer;
    color: #b31e22!important;
  }
  .el-input-group__append, .el-input-group__prepend{
    background-color: #FE4D02!important;
    color: #ffffff!important;
  }
  .menu-index{
    text-align: center;
    padding: 0px 25px;
    /* width: 100px; */
    color: #FFFFFF;
    cursor: pointer;
  }
  .menu-index:hover{
    background-color: #666;
  }
  .menu-active{
    color: #FE7912;
  }

  .scroll-none::-webkit-scrollbar {
    display: none !important;
  }
  .sub-menu:hover{
    cursor: pointer;
    text-decoration-line: underline;
    text-underline: #FFFFFF;
  }
  .big-menu{
    display: none;
  }
  .all-type:hover .big-menu{
    display: block!important;
  }
</style>



// WEBPACK FOOTER //
// src/page/top/index.vue